export default "__VITE_ASSET__D$ncgs8N__"